import React from "react"
import PropTypes from "prop-types"
import { Row, Col } from "react-flexbox-grid"
import MetricCard from "./MetricCard"
import { buildSearchUrl } from "../../util/string"
import Styles from "./Metrics.module.css"

const Metrics = props => {
  const { statistics } = props

  const currentDate = () => `vuoden ${new Date().getFullYear()} aikana`
  const getTimeEndOFYear = () => currentDate()
  const getTimeDuringYear = () => currentDate()

  const getParams = () => {
    return {
      startYearFrom: new Date().getFullYear().toString(),
      location: [{ value: 'home' }]
    }
  }

  if (Object.keys(statistics).length) {
    return (
      <Row className={Styles.content}>
        <Col className={Styles.col} xs={12} sm={4} md={4}>
          <MetricCard
            title="Aktiiviset yritykset kotipaikan mukaan"
            metrics={new Intl.NumberFormat('FI-fi').format(statistics.inCompanyForms.currentlyActive)}
            time={getTimeEndOFYear()}
            modalDirection="left"
          >
            <p>
              Aktiiviset yritykset näyttää kaupunkiseudun aktiivisten yritysten lukumäärän.
              <br />
              <br />
              Yritys on aktiivinen kun se on rekisteröity kaupparekisteriin sekä vähintään yhteen toiseen rekisteriin
              (ALV-rekisteriin, ennakkoperintärekisteriin, tai työnantajarekisteriin) tai yrityksellä on vähintään
              yksi tilinpäätös viimeiseltä kolmelta tilikaudelta, eikä sillä ole mitään erityistilannetta (konkurssi,
              saneeraus, selvitystila, toiminta keskeytynyt tai toiminta lakannut).
              Viimeisen kuuden kuukauden sisään perustetut yritykset ovat automaattisesti aktiivisia.
              <br />
              <br />
              Sisältää seuraavat yhtiömuodot: OY, OYJ, TMI, KY, AY, OSK.
              <br />
              <br />
              Tietolähde: Profinder
            </p>
          </MetricCard>
        </Col>
        <Col className={Styles.col} xs={12} sm={4} md={4}>
          <MetricCard
            title={["Rekisteröidyt"]}
            metrics={[
              `+${statistics.inCompanyForms.registered}`
            ]}
            to={[`/haku/${buildSearchUrl("", getParams())}`]}
            time={getTimeDuringYear()}
            modalDirection="left"
            multipleMetrics
          >
            <p>
              Rekisteröidyt näyttää valitun kaupunkiseudun Kaupparekisteriin rekisteröityjen
              yritysten lukumäärän.
              <br />
              <br />
              Esivalittuna näytetään kuluvan vuoden aikana rekisteröidyt yritykset.
              <br />
              <br />
              Tietolähde: Profinder
            </p>
          </MetricCard>
        </Col>
        <Col className={Styles.col} xs={12} sm={4} md={4}>
          <MetricCard
            title="Poistetut"
            metrics={`-${statistics.inCompanyForms.removed}`}
            time={getTimeEndOFYear()}
            modalDirection="left"
          >
            <p>
              Poistetut näyttää valitun kaupunkiseudun mukaan kuluvana vuonna epäaktiivisiksi määriteltyjen
              yritysten lukumäärän.
              <br />
              <br />
              Tietolähde: Profinder
            </p>
          </MetricCard>
        </Col>
      </Row>
    )
  }
  return null
}

Metrics.propTypes = {
  statistics: PropTypes.shape().isRequired,
  filters: PropTypes.shape().isRequired,
  searchFilters: PropTypes.shape().isRequired,
  setSearchFilters: PropTypes.func.isRequired,
}

export default Metrics
